import { useState, useEffect,} from "react";
import { useNavigate } from "react-router-dom";
import { apiPaths } from "../../../../service/apiPaths";
import ApiService from "../../../../service/ApiService";
import { IAddLanguage, ILanguage } from "../../Language.props";
import { SubmitHandler } from "react-hook-form";
import toast from "react-hot-toast";

const useEditLanguage = (languageId: string) => {
  const [formData, setFormData] = useState<IAddLanguage>({
    languageName: "",
    languageCode:"",
  });
  const [loading, setLoading] = useState<boolean>(false);
  const [language, setLanguage] = useState<ILanguage | null>(null);

  const navigate = useNavigate();

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await ApiService({
        method: "GET",
        endpoint: `${apiPaths.getlanguage}/${languageId}`,
      });
      console.log("response", response);
      setLanguage(response);
      populateFormData(response);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const populateFormData = (languageData: ILanguage) => {
    setFormData({
      languageName: languageData.languageName,
      languageCode: languageData.languageCode,
    });
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { id, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const handleSubmit: SubmitHandler<IAddLanguage> = async () => {
    try {
      const response = await ApiService({
        method: "PUT",
        endpoint: `${apiPaths.updatelanguage}/${languageId}`,
        data: formData,
      });

      if (response !== "undefined") {
        toast.success("Language updated successfully", {
          duration: 10000, // Set the duration in milliseconds
        });
        // alert("Language updated successfully");
        navigate("/language");
        window.location.reload();
      }
    } catch (error) {
      toast.error("Error updating status", {
        duration: 10000, // Set the duration in milliseconds
      });
      console.error("Error updating language:", error);
    }
  };

  const handleCancel = () => {
    window.location.reload();
  };

  return {
    loading,
    formData,
    language,
    handleChange,
    handleSubmit,
    handleCancel,
  };
};

export default useEditLanguage;
